export const TextWithLine = ({ text }) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
        <hr style={{ flexGrow: 1, borderTop: '1px solid rgba(255, 255, 255, 0.20)' }} />
        <span style={{ padding: '0 10px', color: 'rgba(255, 255, 255, 0.20)', fontWeight: 'bold' }}>{text}</span>
        <hr style={{ flexGrow: 1, borderTop: '1px solid rgba(255, 255, 255, 0.20)' }} />
      </div>
    );
  };